import { DynamicDataAttributes } from '@/utils/gaTypes';

const GA_EVENTS = [
  {
    attributes: ['action', 'category', 'label'],
    event: (eventAttributes: DynamicDataAttributes, eventInteraction: boolean = true) => {
      (window as any).dataLayer?.push({
        event: 'trackEvent',
        eventCategory: eventAttributes.category,
        eventAction: eventAttributes.action,
        eventLabel: eventAttributes.label,
        eventInteraction,
      });
    },
  },
  {
    attributes: ['action', 'category'],
    event: (eventAttributes: DynamicDataAttributes, eventInteraction: boolean = true) => {
      (window as any).dataLayer?.push({
        event: 'trackEvent',
        eventCategory: eventAttributes.category,
        eventAction: eventAttributes.action,
        eventInteraction,
      });
    },
  },
];

export default GA_EVENTS;
